"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MeasurementsRegistry = function MeasurementsRegistry() {
    var _this = this;

    _classCallCheck(this, MeasurementsRegistry);

    this.registerElement = function (id) {
        _this.elementReferenceCount[id] = _this.elementReferenceCount[id] || 0;
        _this.elementReferenceCount[id]++;
    };

    this.removeElement = function (id) {
        _this.elementReferenceCount[id]--;
    };

    this.getElementReferenceCount = function (id) {
        return _this.elementReferenceCount[id] || 0;
    };

    this.registerCanvas = function (canvas) {
        _this.canvas = canvas;
    };

    this.removeCanvas = function () {
        _this.canvas = null;
    };

    this.getCanvasScroll = function () {
        var canvasRect = _this.canvas && _this.canvas.getBoundingClientRect();
        return {
            top: _this.canvas && _this.canvas.scrollTop - canvasRect.top || 0,
            left: _this.canvas && _this.canvas.scrollLeft - canvasRect.left || 0
        };
    };

    this.elementReferenceCount = {};
}

// This is required to ensure that measurement removal events are not fired prematurely
;

/**
 * Initialises an instance, for simplicity, because it's being used on the client side.
 */


var measurementsRegistry = new MeasurementsRegistry();
exports.default = measurementsRegistry;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/measurements/measurementsRegistry.js
// module id = 710
// module chunks = 0